import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import NACell from '../Reusable/DataTable/NACell';
import TableActionButton from '../Reusable/TableActionButton';
import DataTable from '../Reusable/DataTable/UserDataTable';

const RoleList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "group_name",
      cell: NACell,
    },
    {
      header: "Allow Permission",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Assign Member",
      accessorKey: "primary_email",
      cell: NACell,
    }
  ];
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  if (userProfileType?.is_staff) {
    defaultColumns.push({
      header: "Action",
      accessorKey: "pk",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },)
  }
  return (
    <DataTable
      url={APIS.GROUP}
      queryKey={"roles"}
      columns={defaultColumns}
      addNewPagePath={userProfileType?.is_staff ? "/role-create" : ""}
      tableName={"Role"}
    />
  )
}

export default RoleList